(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tihex-product-info"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tihex-product-info')) {
  customElements.define('tihex-product-info', class extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.activate = tab => {
        this.tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          const panel = this.querySelector('[id="' + item.getAttribute('aria-controls') + '"]');
          if (panel) panel.hidden = !active;
        });
      };
      this.handleClick = event => {
        const tab = event.target.closest('[role="tab"]');
        if (tab && this.contains(tab)) this.activate(tab);
      };
      this.handleKey = event => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.activate(this.tabs[next]);
        this.tabs[next].focus({preventScroll: true});
        this.tabs[next].scrollIntoView({block: 'nearest', inline: 'nearest'});
      };
      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKey);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKey);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
